/**
 * Convenience function for joining strings to form className chains
 */
export function joinStrings(a, b) {
    return a && b ? "".concat(a, " ").concat(b) : a || b || '';
}
export function joinStringArray(arr, sep) {
    if (arr.length === 0) {
        return '';
    }
    var result = arr[0];
    for (var i = 1; i < arr.length; i++) {
        result += sep ? sep + arr[i] : arr[i];
    }
    return result;
}
//# sourceMappingURL=joinStrings.js.map